import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const ConfirmActionDialog = ({
  open,
  onClose,
  title,
  description,
  confirmPrompt,
  children,
  onConfirm,
  loading = false,
  cancelLabel = "Cancelar",
  confirmLabel = "Aceptar",
  confirmColor = "primary",
  confirmVariant = "contained",
  fullWidth = true,
  maxWidth = "sm",
}) => {
  const handleClose = () => {
    if (!loading) onClose();
  };

  const handleConfirm = async () => {
    await onConfirm?.();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={fullWidth} maxWidth={maxWidth}>
      {title ? <DialogTitle>{title}</DialogTitle> : null}
      <DialogContent>
        {description != null ? (
          <Typography variant="body2" color="text.secondary" sx={{ pt: 0.5 }}>
            {description}
          </Typography>
        ) : null}
        {confirmPrompt != null ? (
          <Typography variant="body2" sx={{ mt: description != null ? 2 : 0.5 }}>
            {confirmPrompt}
          </Typography>
        ) : null}
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          onClick={handleConfirm}
          color={confirmColor}
          variant={confirmVariant}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmActionDialog;
